import { tv } from 'tailwind-variants'

import { body2 } from '@ui-kit/core/typography'

export const chip = tv({
  slots: {
    container:
      'flex h-10 items-center justify-center rounded-3xl bg-ui-grey-50 px-5 hover:opacity-70 active:opacity-70 web:transition-opacity web:duration-300 ',
    text: body2(),
  },
  variants: {
    isActive: {
      true: {
        container: 'bg-brand-dark',
        text: 'text-ui-light',
      },
      false: {
        text: 'opacity-70',
      },
    },
  },
  defaultVariants: {
    isActive: false,
  },
})
